import React from 'react';
import { Card } from '../UI/Card';
import { BrainCircuit, TrendingUp, GraduationCap, MessageCircle, Network, Share2, Users, LayoutTemplate, Award } from 'lucide-react';
export const TrainingAreas = () => {
  const areas = [{
    title: 'AI Training',
    icon: <BrainCircuit className="w-10 h-10 text-primary" data-id="element-1064" />,
    items: ['AI for Educators', 'AI for Professionals', 'AI for Marketing Teams', 'AI productivity tools', 'AI workflow automation']
  }, {
    title: 'Learning and Development',
    icon: <TrendingUp className="w-10 h-10 text-primary" data-id="element-1065" />,
    items: ['Leadership development', 'Professional growth', 'Workplace productivity', 'Learning systems for organizations']
  }, {
    title: 'Teacher Retooling Programs',
    icon: <GraduationCap className="w-10 h-10 text-primary" data-id="element-1066" />,
    items: ['Modern teaching methods', 'Digital classroom tools', 'Curriculum innovation', 'Student engagement strategies']
  }, {
    title: 'Communications & Soft Skills',
    icon: <MessageCircle className="w-10 h-10 text-primary" data-id="element-1067" />,
    items: ['Professional communication', 'Public speaking', 'Workplace collaboration', 'Emotional intelligence']
  }, {
    title: 'Strategic Networking',
    icon: <Network className="w-10 h-10 text-primary" data-id="element-1068" />,
    items: ['Relationship building', 'Professional visibility', 'Partnership development', 'Collaboration strategies']
  }, {
    title: 'Social Media & Digital Growth',
    icon: <Share2 className="w-10 h-10 text-primary" data-id="element-1069" />,
    items: ['Social media strategy', 'Content planning', 'LinkedIn visibility', 'Digital storytelling']
  }, {
    title: 'Community Building & Management',
    icon: <Users className="w-10 h-10 text-primary" data-id="element-1070" />,
    items: ['Community strategy', 'Engagement systems', 'Online community management', 'Volunteer engagement']
  }, {
    title: 'Program Development',
    icon: <LayoutTemplate className="w-10 h-10 text-primary" data-id="element-1071" />,
    items: ['Program design', 'Learning experience design', 'Impact frameworks', 'Monitoring and evaluation']
  }, {
    title: 'Branding',
    icon: <Award className="w-10 h-10 text-primary" data-id="element-1072" />,
    items: ['Personal branding', 'Corporate branding', 'Brand storytelling', 'Thought leadership']
  }];
  return <section className="py-20 bg-white" data-id="element-1073">
      <div className="container mx-auto px-4" data-id="element-1074">
        <div className="text-center mb-16 scroll-animate" data-id="element-1075">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1076">
            Training Areas
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1077">
            Comprehensive capacity building across critical domains for the
            modern workforce.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1078">
          {areas.map((area, index) => <Card key={index} className="scroll-animate hover-lift border-2 border-gray-100 hover:border-primary/30 group transition-all duration-300" style={{
          transitionDelay: `${index % 3 * 100}ms`
        }} data-id="element-1079">
              <div className="p-2" data-id="element-1080">
                <div className="w-16 h-16 bg-gray-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-primary/10 transition-colors duration-300" data-id="element-1081">
                  {area.icon}
                </div>
                <h3 className="text-xl font-bold text-navy mb-4" data-id="element-1082">
                  {area.title}
                </h3>
                <ul className="space-y-3" data-id="element-1083">
                  {area.items.map((item, i) => <li key={i} className="flex items-start text-gray-600" data-id="element-1084">
                      <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2 mr-3 flex-shrink-0" data-id="element-1085"></span>
                      <span data-id="element-1086">{item}</span>
                    </li>)}
                </ul>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
};